import { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  CardFooter,
  Col,
  Form,
  Label,
  Row,
  Nav,
  NavItem,
  NavLink,
  CardHeader,
  CardTitle,
  Button,
} from "reactstrap";
import "./styles.css";
import NavItems from "./NavItems";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import commonService from "../../../services/common.service";
import { getUserProfile } from "../../../helpers/functions_helper";

const ImmigrationInfo = (props: any) => {
  const { t } = useTranslation();
  const userProfile = getUserProfile();
  const [activeApplicationId, setActiveApplicationId] = useState<number | null>(null);
  const [loading, setLoading] = useState(true);
  const [attachmentsList, setAttachmentsList] = useState<any>([]);

  const activeTabData =
    props?.data?.applications?.find((app: any) => app.id === props.activeApplicationId) ||
    props?.data?.applications?.[0];

  const getAttachmentList = async () => {
    setLoading(true);
    const response = await commonService.getAttachmentList({
      module_app_id: 30,
      module_main_id: props?.data?.id,
      module_sub_id: activeTabData?.id,
      section_id: 0,
      file_path: "immigration",
    });
    if (response.data.status === "success") {
      setAttachmentsList(response.data.data.original.data);
      setLoading(false);
    }
  };

  useEffect(() => {
    getAttachmentList();
  }, [props?.data?.id, props?.data?.immigration_id, activeTabData?.id]);

  return (
    <Col lg="6" className="mb-4 mb-lg-0">
      <NavItems />
      <Card className="border-top-0 border-bottom-0 rounded-0 mb-0">
        <CardHeader>
          <CardTitle>
            <div className="btn btn-sm">
              <span className="align-middle material-symbols-outlined fw-light fs-3">
                app_registration
              </span>
            </div>
            {props?.data?.id && props?.data?.immigration_id && activeTabData?.id ? (
              <Link
                to={`/immigration/update-application/${props?.data?.id}/${props?.data?.immigration_id}/${activeTabData?.id}`}
                className="text-decoration-none"
              >
                Application ID #{activeTabData?.application_id || ""}
              </Link>
            ) : (
              "Application ID #"
            )}
          </CardTitle>
        </CardHeader>

        <CardBody className="tab-content-body">
          <div className="tab-section">
            <div className="section-content">
              <div className="detail-row mb-4">
                <div className="detail-col">
                  <label className="label-text text-muted">Visa Type</label>
                  <p className="detail-value">
                    {activeTabData?.application_visa_type?.visa_type_value || ""}
                  </p>
                </div>

                <div className="detail-col">
                  <label className="label-text text-muted">Application Country</label>
                  <p className="detail-value">{activeTabData?.application_country?.name || ""}</p>
                </div>

                <div className="detail-col">
                  <label className="label-text text-muted">Submission Date</label>
                  <p className="detail-value">{activeTabData?.application_submission_date || ""}</p>
                </div>

                <div className="detail-col">
                  <label className="label-text text-muted">Status</label>
                  <p className="detail-value">
                    <span className="badge bg-success">
                      {activeTabData?.application_status?.application_status_value || ""}
                    </span>
                  </p>
                </div>
              </div>

              <div className="detail-row mb-4">
                <div className="detail-col">
                  <label className="label-text text-muted">Start date</label>
                  <p className="detail-value">{activeTabData?.application_start_date || ""}</p>
                </div>
                <div className="detail-col">
                  <label className="label-text text-muted">Expiry date</label>
                  <p className="detail-value">{activeTabData?.application_expiry_date || ""}</p>
                </div>
                <div className="detail-col">
                  <label className="label-text text-muted">Number of Entries</label>
                  <p className="detail-value">
                    <span className="badge bg-info">
                      {activeTabData?.number_of_entries?.number_of_entries_value || ""}
                    </span>
                  </p>
                </div>
              </div>

              {!activeTabData?.under_renewal ? (
                <div className="renewal-alert mb-4">
                  <div className="alert-badge">
                    Renewal due in {activeTabData?.application_duration || 0} days
                  </div>
                  <Link
                    className="btn btn-sm bg-primary text-white"
                    to={`/immigration/create-application/${props?.data?.id}/${props?.data?.immigration_id}?renewal_id=${activeTabData?.id}`}
                  >
                    Start renewal
                  </Link>
                </div>
              ) : null}

              {activeTabData?.under_renewal ? (
                <div className="renewal-alert mb-4">
                  <div className="alert-badge">Application is under renewal</div>
                  <Link
                    className="btn btn-sm bg-info text-white"
                    to={`/immigration/update-application/${props?.data?.id}/${props?.data?.immigration_id}/${activeTabData?.renewal_id}`}
                  >
                    Update application
                  </Link>
                </div>
              ) : null}
            </div>

            <div className="documents-section">
              <h6 className="section-title">DOCUMENTS</h6>

              {attachmentsList &&
                attachmentsList.length > 0 &&
                attachmentsList.map((data: any) => (
                  <div className="document-item">
                    <div className="doc-name">
                      {data.type === "file" ? (
                        <span
                          className="link-primary"
                          title={data.file_name}
                          // onClick={() => onClickDownload(data)}
                        >
                          {data.file_name.substring(0, 50)}
                          {data.file_name.length >= 50 && "..."}
                          {"."}
                          {data.file_extension}
                        </span>
                      ) : (
                        <>
                          <a
                            href={data.file_extension ? data.file_name_source : data.file_name}
                            className="text-decoration-underline"
                            target="_blank"
                          >
                            {data.file_extension === "" || data.file_extension === null ? (
                              data.short_description ? (
                                <>
                                  {data.short_description.substring(0, 50)}
                                  {data.short_description.length >= 50 && "..."}
                                </>
                              ) : (
                                <>
                                  {data.file_name.substring(0, 50)}
                                  {data.file_name.length >= 50 && "..."}
                                </>
                              )
                            ) : (
                              <>
                                {data.file_name.substring(0, 50)}
                                {data.file_name.length >= 50 && "..."}
                                {data.file_extension && "." + data.file_extension}
                              </>
                            )}
                          </a>
                        </>
                      )}

                      {data.version_count > 0 ? (
                        <span className="badge bg-success ms-1" title={t("Version")}>
                          {data.version_count}
                        </span>
                      ) : null}

                      {(data.type === "link" && data.file_extension) ||
                      data.attachment_for_ids_array ? (
                        <div className="mt-2"></div>
                      ) : null}

                      {data.type === "link" && data.file_extension ? (
                        <>
                          <span className="badge_custome badge-soft-secondary badge bg-secondary rounded-pill me-2">
                            <span className="align-middle material-symbols-outlined fw-light fs-5 me-1">
                              grid_view
                            </span>
                            {t("SharePoint file")}
                          </span>
                        </>
                      ) : null}

                      {data.attachment_for_ids_array ? (
                        <>
                          {data.attachment_for_ids_array.map((user_data: any, idx: number) => (
                            <span
                              key={idx}
                              title={`Shared with ${
                                user_data.first_name + " " + user_data.last_name
                              }`}
                              className={`badge_custome badge ${user_data.id === userProfile.USER_ID ? "badge-soft-primary bg-primary" : "badge-soft-info bg-info"} rounded-pill me-2`}
                            >
                              <span className="align-middle material-symbols-outlined fw-light fs-5 me-1">
                                alternate_email
                              </span>
                              {user_data.first_name + " " + user_data.last_name}
                            </span>
                          ))}
                        </>
                      ) : null}

                      {data.short_description &&
                        data.file_extension !== "" &&
                        data.file_extension !== null && (
                          <p
                            className="font-size-12 text-info mb-2"
                            style={{ whiteSpace: "normal" }}
                          >
                            {data.short_description}
                          </p>
                        )}
                    </div>

                    <div className="doc-status verified">Verified</div>
                  </div>
                ))}

              {/* <div className="document-item">
                <div className="doc-name">Passport</div>
                <div className="doc-status verified">Verified</div>
              </div> */}
              {/* <div className="document-item">
                <div className="doc-name">Residence permit</div>
                <div className="doc-status pending">Pending</div>
              </div> */}

              {props?.data?.id && props?.data?.immigration_id && activeTabData?.id ? (
                <Link
                  to={`/immigration/update-documents/${props?.data?.id}/${props?.data?.immigration_id}/${activeTabData?.id}`}
                  className="btn btn-outline-primary w-100"
                >
                  Upload documents
                </Link>
              ) : null}
            </div>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default ImmigrationInfo;
